import React from 'react';
import { styled } from 'styled-components';
import AppCSS from '../../utils/styled';

export function EmptyState() {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon>💬</EmptyStateIcon>
      <EmptyStateTitle>Start a conversation</EmptyStateTitle>
      <EmptyStateDescription>
        Send a message to begin chatting with the AI assistant. Your conversation will appear here.
      </EmptyStateDescription>
    </EmptyStateContainer>
  );
}

const EmptyStateContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px;
  text-align: center;
`;

const EmptyStateIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${AppCSS.colors.blues.veryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  ${AppCSS.fonts.h2};
  color: ${AppCSS.colors.blues.primary};
`;

const EmptyStateTitle = styled.h3`
  ${AppCSS.fonts.h3};
  color: ${AppCSS.colors.black};
  margin: 0;
`;

const EmptyStateDescription = styled.p`
  ${AppCSS.fonts.label14Regular};
  color: ${AppCSS.colors.greys.medium};
  margin: 0;
  max-width: 400px;
`;

const TypingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${AppCSS.colors.white};
  border: 1px solid ${AppCSS.colors.greys.light};
  ${AppCSS.radiuses.regular};
  border-bottom-left-radius: 4px;
  max-width: 70%;
  ${AppCSS.boxShadows.block};
`;
